import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SeoService } from '@core/services/seo.service';
import { FaConfig } from '@fortawesome/angular-fontawesome';
import { FcConfirmComponent } from '@shared/components/fc-confirm/fc-confirm.component';
import { FcToastComponent } from '@shared/components/fc-toast/fc-toast.component';

@Component({
  selector: 'fc-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  imports: [RouterOutlet, FcToastComponent, FcConfirmComponent],
})
export class AppComponent {
  constructor() {
    inject(SeoService).init();
    // Icon CSS ships in the bundled stylesheet, not inline in every page.
    inject(FaConfig).autoAddCss = false;
  }
}
